

import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect } from "react"
import PageTopTitle from "../../shared/PageTopTitle"
import { showModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import Btn from "../../shared/button/Btn"
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { coy } from 'react-syntax-highlighter/dist/esm/styles/prism';

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: auto;
        min-width: 500px;
        max-width: 900px;
        height: 700px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;

        .content{
            margin-top: 20px;
            padding: 100px;
            padding-top: 20px !important;
            display: flex;
            width: 100%;
            flex-direction: column;
            align-items: center;
            gap: 5px;
            height:570px;
            overflow: auto;
            
                &::-webkit-scrollbar {
                    width: 0;
                    width: 8px;
                }
                &::-webkit-scrollbar-thumb {
                    background-color: #9e9b9b;
                    border-radius: 10px;
                }
                &::-webkit-scrollbar-track {
                    background-color: transparent;
                }
                
                .code-data{
                    width: 100%;
                    font-size: var(--font-size-md);
                    font-weight: var(--font-weight-lg);
                    white-space: pre-wrap;
                }
            }

        }


        .btn-container{
            height: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            width: 95%;
            border-top: 1px solid;
            border-color: ${({ theme }) => theme.mainBorderColor};
            background-color: ${({theme}) => theme.mainBgColor};
            margin-right: 8px;
            position: absolute;
            bottom: 0;
        }
`
const ReqResModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const {islemKayitItemReqResData } = useSelector(state => state.admin3)
    const { lockScroll, unlockScroll } = useScrollLock();

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <PageTopTitle title={islemKayitItemReqResData.type === "req" ? "İstek Verisi" : "Cevap Verisi"}/>
            <div className="content">
                <div className="code-data">
                    <SyntaxHighlighter language="json" style={coy}>
                        {JSON.stringify(islemKayitItemReqResData.data, null, "\t")}
                    </SyntaxHighlighter>
                </div>
                <div className="btn-container">
                    <Btn bgColor="#E85446" color="#fff" width={"240px"} handleClick={() => dispatch(showModal(null))}>Kapat</Btn>
                </div>
            </div>
        </div>
    </ModalContainer>
  )
}


export default ReqResModal